import { api } from "@/lib/api";

export const pushSupported =
  typeof window !== "undefined" &&
  "serviceWorker" in navigator &&
  "PushManager" in window &&
  "Notification" in window;

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

async function getRegistration() {
  const reg = await navigator.serviceWorker.register("/push-sw.js");
  await navigator.serviceWorker.ready;
  return reg;
}

export async function getPushStatus() {
  if (!pushSupported) return { supported: false, this_device: false };
  try {
    const reg = await navigator.serviceWorker.getRegistration("/push-sw.js");
    const sub = reg ? await reg.pushManager.getSubscription() : null;
    const { data } = await api.get("/push/status", {
      params: sub ? { endpoint: sub.endpoint } : {},
    });
    return { supported: true, permission: Notification.permission, ...data };
  } catch {
    return { supported: true, permission: Notification.permission, this_device: false };
  }
}

export async function enablePush() {
  if (!pushSupported) throw new Error("This browser doesn't support push notifications.");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Notification permission was blocked.");

  const reg = await getRegistration();
  const { data } = await api.get("/push/public-key");
  if (!data.publicKey) throw new Error("Push is not configured on the server.");

  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.publicKey),
    });
  }
  await api.post("/push/subscription", sub.toJSON());
  return true;
}

export async function disablePush() {
  const reg = await navigator.serviceWorker.getRegistration("/push-sw.js");
  const sub = reg ? await reg.pushManager.getSubscription() : null;
  if (sub) {
    await api.post("/push/unsubscribe", { endpoint: sub.endpoint }).catch(() => {});
    await sub.unsubscribe().catch(() => {});
  }
  return true;
}

export async function sendTestPush() {
  await api.post("/push/test");
}
